/**
 * Cálculo de frete (theme.shipping): PDP, drawer do carrinho, BrasilAPI + cart/shipping_rates.json.
 * Depende apenas de global.js (objeto theme). Liga clique/Enter/máscara por delegação (fim do arquivo).
 *
 * Ordem no layout: após global.js, antes de cart.js.
 */

theme.shipping = {
    /* Texto traduzido da calculadora (data-label-* em snippets/frete-dinamico.liquid) */
    label: function (wrapper, name) {
      var root = wrapper.closest('.frete-dinamico');
      return root ? root.dataset[name] : '';
    },

    calculateShippingRates: async function (btn) {
      if (!btn) {
        return;
      }

      const wrapper = btn.closest('#cart-shipping-rates-collapse') || document.querySelector('#cart-shipping-rates-collapse');

      if (!wrapper) {
        return;
      }

      const zipInput = wrapper.querySelector('#shipping-rates-modal-zip');
      if (!zipInput) {
        return;
      }

      btn.disabled = true;
      theme.utilities.toggleSpinner(btn, true);

      const btnContent = btn.querySelector('.btn-content');
      if (btnContent) {
        btn.dataset.originalText = btnContent.textContent;
        btnContent.textContent = this.label(wrapper, 'labelCalculating');
      }

      const zip = zipInput.value;

      const dangerElement = wrapper.querySelector('#frete-danger');
      const avisoElement = wrapper.querySelector('#frete-aviso');
      const sucessoElement = wrapper.querySelector('#frete-sucesso');

      if (dangerElement) {
        dangerElement.innerHTML = '';
        dangerElement.setAttribute('hidden', 'hidden');
      }
      if (avisoElement) {
        avisoElement.innerHTML = '';
        avisoElement.setAttribute('hidden', 'hidden');
      }
      if (sucessoElement) {
        sucessoElement.innerHTML = '';
        sucessoElement.setAttribute('hidden', 'hidden');
      }

      const cepUnmasked = zip.replace(/\D/g, '');
      const cepRegex = /^[0-9]{8}$/;

      if (!cepRegex.test(cepUnmasked)) {
        const avisoElement = wrapper.querySelector('#frete-aviso');
        if (avisoElement) {
          avisoElement.innerHTML = `<p>${this.label(wrapper, 'labelInvalidZip')}</p>`;
          avisoElement.removeAttribute('hidden');
        }
        this.resetButton(btn);
        return;
      }

      try {
        const isCartDrawer = this.isCartDrawer(btn);


        if (isCartDrawer) {
          await this.tryCalculateShippingRates(wrapper, cepUnmasked);
        } else {
          await this.calculateProductShipping(wrapper, cepUnmasked);
        }
      } catch (error) {
        console.error('Erro:', error);
      }

      this.resetButton(btn);
    },

    isCartDrawer: function (btn) {
      return !!btn.closest('#CartDrawer');
    },

    calculateProductShipping: async function (wrapper, cepUnmasked) {

      const country = 'BR';
      const brasilApiUrl = `https://brasilapi.com.br/api/cep/v1/${cepUnmasked}`;

      let data;
      try {
        const response = await fetch(brasilApiUrl);
        if (response.ok) {
          data = await response.json();
        } else {
          throw new Error('Erro ao buscar CEP na BrasilAPI');
        }
      } catch (error) {
        const avisoElement = wrapper.querySelector('#frete-aviso');
        if (avisoElement) {
          avisoElement.innerHTML = `<p>${this.label(wrapper, 'labelZipNotFound')}</p>`;
          avisoElement.removeAttribute('hidden');
        }
        return;
      }

      const formattedLocation = this.formatLocation(data);
      const sucessoElement = wrapper.querySelector('#frete-sucesso');
      if (sucessoElement) {
        sucessoElement.innerHTML = `<p class="frete-dinamico__local small-text"><strong>${formattedLocation}</strong></p>`;
      }

      const province = data.state;

      const cartResponse = await fetch('/cart.js', { method: 'GET' });
      const cartData = await cartResponse.json();
      const originalItems = cartData.items || [];
      const hasItems = originalItems.length > 0;


      if (hasItems) {
        const backupCart = originalItems.map((item) => ({
          id: item.variant_id,
          quantity: item.quantity,
        }));


        await fetch('/cart/clear.js', { method: 'POST' });

        await this.addTemporaryProduct();

        await this.fetchShippingRates(cepUnmasked, country, province, wrapper);

        await fetch('/cart/clear.js', { method: 'POST' });

        for (const item of backupCart) {
          await fetch('/cart/add.js', {
            method: 'POST',
            body: JSON.stringify({ id: item.id, quantity: item.quantity }),
            headers: {
              'Content-Type': 'application/json',
            },
          });
        }
      } else {
        await this.addTemporaryProduct();

        await this.fetchShippingRates(cepUnmasked, country, province, wrapper);

        await fetch('/cart/clear.js', { method: 'POST' });
      }
    },

    addTemporaryProduct: async function () {

      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');
      const quantInput = document.querySelector('.product-detail .product-quantity__input');

      let quantidade = 1;

      if (variantId && quantInput) {
        quantidade = parseInt(quantInput.value) || 1;
      }


      if (variantId) {
        await fetch('/cart/add.js', {
          method: 'POST',
          body: JSON.stringify({ id: variantId, quantity: quantidade }),
          headers: { 'Content-Type': 'application/json' },
        });
      } else {
        const formInput = document.querySelector('.product-form input[name="id"]');
        const selectedVariantId = formInput ? formInput.value : null;

        if (selectedVariantId) {
          await fetch('/cart/add.js', {
            method: 'POST',
            body: JSON.stringify({ id: selectedVariantId, quantity: quantidade }),
            headers: { 'Content-Type': 'application/json' },
          });
        } else {
          const productHandle = window.location.pathname.split('/').pop();

          const productResponse = await fetch(`/products/${productHandle}.js`);
          const productData = await productResponse.json();

          if (productData.variants && productData.variants.length > 0) {
            const availableVariant = productData.variants.find(v => v.available) || productData.variants[0];
            await fetch('/cart/add.js', {
              method: 'POST',
              body: JSON.stringify({ id: availableVariant.id, quantity: quantidade }),
              headers: { 'Content-Type': 'application/json' },
            });
          } else {
          }
        }
      }
    },



    resetButton: function (btn) {
      if (!btn) return;

      btn.disabled = false;
      theme.utilities.toggleSpinner(btn, false);

      const btnContent = btn.querySelector('.btn-content');
      if (btnContent) {
        btnContent.textContent = btn.dataset.originalText;
      }
    },

    tryCalculateShippingRates: async function (wrapper, cepUnmasked) {

      if (!wrapper) {
        return;
      }

      const country = 'BR';
      const brasilApiUrl = `https://brasilapi.com.br/api/cep/v1/${cepUnmasked}`;

      let data;
      try {
        const response = await fetch(brasilApiUrl);
        if (response.ok) {
          data = await response.json();
        } else {
          throw new Error('Erro ao buscar CEP na BrasilAPI');
        }
      } catch (error) {
        const avisoElement = wrapper.querySelector('#frete-aviso');
        if (avisoElement) {
          avisoElement.innerHTML = `<p>${this.label(wrapper, 'labelZipNotFound')}</p>`;
          avisoElement.removeAttribute('hidden');
        }
        return;
      }

      const formattedLocation = this.formatLocation(data);
      const sucessoElement = wrapper.querySelector('#frete-sucesso');
      if (sucessoElement) {
        sucessoElement.innerHTML = `<p class="frete-dinamico__local small-text"><strong>${formattedLocation}</strong></p>`;
      }

      const province = data.state;

      await this.fetchShippingRates(cepUnmasked, country, province, wrapper);
    },

    fetchShippingRates: async function (cepUnmasked, country, province, wrapper) {

      if (!wrapper) {
        return;
      }

      const ratesUrl = `/cart/shipping_rates.json?shipping_address[zip]=${cepUnmasked}&shipping_address[country]=${country}&shipping_address[province]=${province}`;

      const ratesResponse = await fetch(ratesUrl, { method: 'GET' });
      const ratesData = await ratesResponse.json();

      if (ratesResponse.ok && ratesData.shipping_rates.length > 0) {
        let ratesHtml = '';
        ratesData.shipping_rates.forEach((rate) => {
          const formattedPrice = Number(rate.price) === 0 ? this.label(wrapper, 'labelFree') : this.formatCurrency(rate.price);
          const deliveryDays =
            rate.delivery_days && rate.delivery_days.length > 0 ? this.formatDeliveryDays(wrapper, rate.delivery_days) : '';
          ratesHtml += `<div><strong>- ${rate.name}</strong>: ${formattedPrice} ${deliveryDays}</div>`;
        });

        const sucessoElement = wrapper.querySelector('#frete-sucesso');
        if (sucessoElement) {
          sucessoElement.innerHTML += ratesHtml;
          sucessoElement.removeAttribute('hidden');
        }
      } else {
        const avisoElement = wrapper.querySelector('#frete-aviso');
        if (avisoElement) {
          avisoElement.innerHTML = `<p>${this.label(wrapper, 'labelNoRates')}</p>`;
          avisoElement.removeAttribute('hidden');
        }
      }
    },

    formatLocation: function (data) {
      return `${data.city || data.localidade} - ${data.neighborhood || data.bairro || ''} - ${data.street || data.logradouro || ''}`;
    },

    formatDeliveryDays: function (wrapper, deliveryDays) {
      const lastDay = deliveryDays[deliveryDays.length - 1];
      return '- ' + (lastDay === 1 ? this.label(wrapper, 'labelDay') : this.label(wrapper, 'labelDays').replace('[days]', lastDay));
    },

    formatCurrency: function (value) {
      return theme.utilities.formatMoney(Math.round(value * 100));
    },

};

/* Uma ligação só para todas as calculadoras (snippets/frete-dinamico.liquid), inclusive as que chegam
   por AJAX (gaveta do carrinho) ou pelo editor: "Calcular", Enter no CEP e máscara 00000-000. */
document.addEventListener("click", function (e) {
  var btn = e.target.closest("[data-shipping-calc]");
  if (!btn) return;
  e.preventDefault();
  theme.shipping.calculateShippingRates(btn);
});

document.addEventListener("keydown", function (e) {
  if (e.key !== "Enter") return;
  var zip = e.target.closest("[data-shipping-zip]");
  if (!zip) return;
  e.preventDefault();
  var btn = zip.closest("#cart-shipping-rates-collapse").querySelector("[data-shipping-calc]");
  if (btn && !btn.disabled) theme.shipping.calculateShippingRates(btn);
});

document.addEventListener("input", function (e) {
  var zip = e.target.closest("[data-shipping-zip]");
  if (!zip) return;
  var digits = zip.value.replace(/\D/g, "");
  zip.value = digits.length > 5 ? digits.slice(0, 5) + "-" + digits.slice(5, 8) : digits;
});
